export default "__VITE_ASSET__fwTyaKK0__"